// @ts-nocheck
import positionDown from "assets/images/positionDown.png";
import positionLeft from "assets/images/positionLeft.png";
import positionRight from "assets/images/positionRight.png";
import positionUp from "assets/images/positionUp.png";
import AddressStyledPanel from "components/AddressStyledPanel";
import DDCTokenSelection, { NFTItem } from "components/CurrencyInputPanel/ddcToken";
import AddressDropdown from "components/Dropdown/AddressDropdown";
import { loadingOpacityMixin } from "components/Loader/styled";
import { RowBetween } from "components/Row";
import TransactionConfirmationModal, { ConfirmationModalContent } from "components/TransactionConfirmationModal";
import { BigNumber, ethers } from 'ethers'
import { useToken } from "hooks/Tokens";
import useActiveWeb3React from "hooks/useActiveWeb3React";
import { useCallback, useEffect, useMemo, useState } from 'react'
import { TransactionType } from "state/transactions/actions";
import { useTransactionAdder } from "state/transactions/hooks";
import styled from "styled-components/macro";
import { PositionType } from "types/position";
import { TransactionResponse } from "@ethersproject/providers";
import {
    useClubManagerContract,
    useDoubleDownClubContract
} from "../../hooks/useContract";
import { Input as NumericalInput } from "../NumericalInput";
import { CAPITAL_TYPE } from "./enums";
import useClubManager from '../../hooks/useClubManager'

const PrimaryPositionIdData = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;

  > * {
    margin-right: 8px;
  }
`

const SelectLabel = styled.div`
    font-weight: 600;
    font-size: 24px;
    line-height: 40px;
    color: white;
`

const ListItemLabel = styled.p`
  font-size: 18px;
  line-height: 22px;
  height: 22px;
  font-weight: 600;
`

const NumericalInputContainer = styled.div`
    max-width: 100px;
    background: linear-gradient(73.6deg,#85FFC4 2.11%,#5CC6FF 42.39%,#BC85FF 85.72%);
    border-radius: 100px;
    padding: 1px;
`

const StyledNumericalInput = styled(NumericalInput) <{ $loading: boolean, disabled: boolean }>`
  ${loadingOpacityMixin};
  font-size: 20px;
    border-radius: 100px;
  line-height: 38px;
  font-weight: 400;
  opacity: ${({ disabled }) => (!disabled ? 1 : 0.45)};
    background: #2F2A3C;
  text-align: left;
`

interface DDCListItemProps {
    setActiveKey: (value: CAPITAL_TYPE | null) => void;
    activeKey: CAPITAL_TYPE | null;
    key: string;
    positionDetails: PositionType;
    index: number,
}

export default function DDCListItem({ setActiveKey, activeKey, positionDetails, index }: DDCListItemProps) {
    const {
        asset: tokenAddress,
        amount: positionAmount,
        type: positionType,
        tokenIds
    } = positionDetails
    const { supplyAllowance, capPerDDC } = useClubManager();
    const { account } = useActiveWeb3React()
    const token = useToken(tokenAddress)
    const [collapse, setCollapse] = useState(true)

    const [txHash, setTxHash] = useState<string>('')
    const [loading, setLoading] = useState<boolean>(false)
    const [showConfirm, setShowConfirm] = useState<boolean>(false)
    const [attemptingTxn, setAttemptingTxn] = useState<boolean>(false) // clicked confirm

    const [undelegateItems, setUndelegateItems] = useState<string[]>([])
    const [nftItem, setNftItem] = useState<NFTItem | null>(null)
    const [invalidAddress, setInvalidAddress] = useState<boolean>(true)
    const [invalidAmount, setInvalidAmount] = useState<boolean>(true)
    const addTransaction = useTransactionAdder()
    const ddcContract = useDoubleDownClubContract(true)!
    const managerContract = useClubManagerContract(true)!

    const [amount, setAmount] = useState<string>('0')
    const [address, setAddress] = useState<string>('')
    const [delegatedAllowance, setDelegatedAllowance] = useState(0);
    

    const onChangeAddress = (address: string) => {
        setAddress(address)
        setInvalidAddress(!ethers.utils.isAddress(address) || account?.toLowerCase() === address.toLowerCase())
    }

    const onUserInput = (value: string) => {
        if (value.length > 0) {
            setInvalidAmount(parseInt(value) === 0 ? true : parseInt(value) > positionAmount)
            setAmount(parseInt(value).toString())
        } else {
            setInvalidAmount(true)
            setAmount("0")
        }
    }

    const parseNumber = (num : BigNumber) => {
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    const notEnoughAllowance = useMemo(() => {
        return parseFloat(supplyAllowance) < parseFloat(capPerDDC)
    }, [supplyAllowance, capPerDDC]);

    useEffect(() => {
        if (positionType === activeKey) {
            setCollapse(false)
        } else {
            setCollapse(true)
        }
    }, [activeKey, positionType])

    useEffect(() => {
        if (positionType === CAPITAL_TYPE.UNDELEGATE) {
            const delegatorList = tokenIds.map((item) => {
                return item?.to;
            });
            setUndelegateItems(delegatorList);
        }
    }, [positionType, tokenIds])

    const handleDismissConfirmation = useCallback(() => {
        setShowConfirm(false)
        // if there was a tx hash, we want to clear the input
        if (txHash) {
            setTxHash('')
        }
    }, [txHash])

    const onChangeCollapse = () => {
        if (collapse) {
            setActiveKey(positionType)
        } else {
            setActiveKey(null)
        }
    }

    const onDeposit = async () => {
        try {
            if (positionAmount > 0) {
                setLoading(true)

                const response: TransactionResponse = await ddcContract['safeTransferFrom(address,address,uint256)'](account, managerContract.address, nftItem?.id)
                addTransaction(response, {
                    type: TransactionType.DDC_DEPOSIT
                })
                setTxHash(response.hash)
                setShowConfirm(true);
                await response.wait()
            }
        } catch (error) {
            console.error('Failed to send transaction', error)
            // we only care if the error is something _other_ than the user rejected the tx
            if (error?.code !== 4001) {
                console.error(error)
            }
        } finally {
            setNftItem(null)
            setLoading(false)
            setAttemptingTxn(false)
        }
    }

    const onWithdraw = async () => {
        try {
            if (positionAmount > 0) {
                setLoading(true)

                const response: TransactionResponse = await managerContract.withdraw(nftItem?.id);
                addTransaction(response, {
                    type: TransactionType.DDC_WITHDRAW
                })
                setTxHash(response.hash)
                setShowConfirm(true);
                await response.wait()
            }
        } catch (error) {
            console.error('Failed to send transaction', error)
            // we only care if the error is something _other_ than the user rejected the tx
            if (error?.code !== 4001) {
                console.error(error)
            }
        } finally {
            setNftItem(null)
            setLoading(false)
            setAttemptingTxn(false)
        }
    }

    const onDelegate = async () => {
        try {
            if (positionAmount > 0 && !invalidAddress && !invalidAmount && !notEnoughAllowance) {
                setLoading(true)

                const response: TransactionResponse = await managerContract.delegate(address, amount);
                addTransaction(response, {
                    type: TransactionType.DDC_DELEGATE
                })
                setTxHash(response.hash)
                setShowConfirm(true);
                await response.wait()
            }
        } catch (error) {
            console.error('Failed to send transaction', error)
            // we only care if the error is something _other_ than the user rejected the tx
            if (error?.code !== 4001) {
                console.error(error)
            }
        } finally {
            setLoading(false)
            setAttemptingTxn(false)
        }
    }

    const onUndelegate = async () => {
        try {
            if (positionAmount > 0 && address && !invalidAmount && parseFloat(parseNumber(delegatedAllowance)) >= parseFloat(parseNumber(capPerDDC)) * amount) {
                setLoading(true)

                const response: TransactionResponse = await managerContract.undelegate(address, amount);
                addTransaction(response, {
                    type: TransactionType.DDC_UNDELEGATE
                })
                setTxHash(response.hash)
                setShowConfirm(true);
                await response.wait()
            }
        } catch (error) {
            console.error('Failed to send transaction', error)
            // we only care if the error is something _other_ than the user rejected the tx
            if (error?.code !== 4001) {
                console.error(error)
            }
        } finally {
            setLoading(false)
            setAttemptingTxn(false)
        }
    }

    const handleItemSelect = (item: NFTItem) => {
        setNftItem(item)
    }

    const onChangeContent = async (value: string) => {
        setAddress(value);
        const amountList = tokenIds.filter((item) => {
            return item.to === value;
        })
        setAmount(amountList[0].amount);
        if(value)
        {
            const allowance = await managerContract.getSupplyAllowance(value);
            setDelegatedAllowance(allowance);
        }
        setInvalidAmount(false)
    }

    return (
        <>
            <TransactionConfirmationModal
                isOpen={showConfirm}
                onDismiss={handleDismissConfirmation}
                attemptingTxn={attemptingTxn}
                hash={txHash}
                content={() => (
                    <ConfirmationModalContent
                        title={'Confirm Withdraw'}
                        onDismiss={handleDismissConfirmation}
                        bottomContent={() => (
                            <button className='view-etherscan'>
                                <p>
                                    View on Block explorer
                                </p>
                            </button>
                        )}
                    />
                )}
            />
            <RowBetween>
                <>
                    <div className='single-liquidity' style={index % 2 === 0 ? { backgroundColor: '#2F2A3C', position: 'relative' } : { backgroundColor: '#201D29', position: 'relative' }}>
                        <div onClick={onChangeCollapse} style={{ cursor: 'pointer' }}>
                            <div className='single-liquidity-header'>
                                <div className='single-liquidity-header-left'>
                                    <PrimaryPositionIdData>
                                        {
                                            token &&
                                            <>
                                                {
                                                    (
                                                        positionType === CAPITAL_TYPE.DEPOSIT
                                                            ?
                                                            <img src={positionRight} width="100%" height="100%" alt="logo" />
                                                            :
                                                            (
                                                                positionType === CAPITAL_TYPE.WITHDRAW ?
                                                                    <img src={positionLeft} width="100%" height="100%" alt="logo" />
                                                                    :
                                                                    (
                                                                        positionType === CAPITAL_TYPE.DELEGATE ?
                                                                            <img src={positionDown} width="100%" height="100%" alt="logo" />
                                                                            :
                                                                            <img src={positionUp} width="100%" height="100%" alt="logo" />
                                                                    )
                                                            )
                                                    )
                                                }
                                                <ListItemLabel>
                                                    {positionDetails.text}
                                                </ListItemLabel>
                                                &nbsp;
                                            </>
                                        }
                                    </PrimaryPositionIdData>
                                </div>
                                <div className='single-liquidity-header-right'>
                                    <p style={{ marginRight: '10px' }}>{positionAmount}</p>
                                    <img src='./images/up2.png' alt="up"
                                        style={{ width: '20px', height: '20px', display: collapse ? 'none' : 'block' }} />
                                    <img src='./images/down2.png' alt="down"
                                        style={{ width: '20px', height: '20px', display: collapse ? 'block' : 'none' }} />
                                </div>
                            </div>
                        </div>
                        <div
                            className='single-liquidity-content'
                            style={{
                                height: (
                                    collapse
                                        ? '0px'
                                        : ((positionType === CAPITAL_TYPE.DEPOSIT || positionType === CAPITAL_TYPE.WITHDRAW) ? '122px' : '170px')
                                ),
                                overflow: 'hidden'
                            }}
                        >
                            <div style={{
                                display: collapse ? 'none' : 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'space-between'
                            }}>
                                <RowBetween style={{ margin: '16px 0' }}>
                                    {
                                        (positionType === CAPITAL_TYPE.DEPOSIT || positionType === CAPITAL_TYPE.WITHDRAW) &&
                                        <>
                                            <SelectLabel style={{ fontSize: "24px", color: "white", fontWeight: 600, lineHeight: '40px' }}>
                                                DDC
                                            </SelectLabel>
                                            <div className='toToken' style={{ display: collapse ? 'none' : 'flex', justifyContent: "space-between", position: 'absolute', right: '24px', transition: 'all 3s linear' }}>
                                                <DDCTokenSelection
                                                    onItemSelect={handleItemSelect}
                                                    nftItem={nftItem}
                                                    items={tokenIds}
                                                    id="add-liquidity-input-tokenb"
                                                    disabled={false}
                                                    value={""}
                                                    onUserInput={(value: string): void => {
                                                        throw new Error("Function not implemented.");
                                                    }}
                                                />
                                            </div>
                                        </>
                                    }
                                    {
                                        (positionType === CAPITAL_TYPE.DELEGATE) &&
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                                <SelectLabel style={{ fontSize: "18px", color: "white", fontWeight: 600, lineHeight: '22px', marginRight: '16px' }}>
                                                    Address:
                                                </SelectLabel>
                                                <AddressStyledPanel id="recipient" placeholder="Enter an address" value={address} onChange={onChangeAddress} />
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 16 }}>
                                                <SelectLabel style={{ fontSize: "18px", color: "white", fontWeight: 600, lineHeight: '22px', marginRight: '16px' }}>
                                                    Amount:
                                                </SelectLabel>
                                                <NumericalInputContainer>
                                                    <StyledNumericalInput
                                                        className='token-amount-input'
                                                        value={amount}
                                                        onUserInput={onUserInput}
                                                        maxBalance={100}
                                                        disabled={false}
                                                        style={{ width: '100%', textAlign: 'right', padding: '0 20px' }}
                                                        $loading={loading}
                                                    />
                                                </NumericalInputContainer>
                                            </div>
                                        </div>
                                    }
                                    {
                                        positionType === CAPITAL_TYPE.UNDELEGATE &&
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 8 }}>
                                                <SelectLabel style={{ fontSize: "18px", color: "white", fontWeight: 600, lineHeight: '22px', marginRight: '16px' }}>
                                                    Address:
                                                </SelectLabel>
                                                <div className='' style={{ display: collapse ? 'none' : 'flex', justifyContent: "space-between", position: 'absolute', right: '24px', transition: 'all 3s linear', width: 255 }}>
                                                    <AddressDropdown onUserClick={onChangeContent} items={undelegateItems} textContent={address} />
                                                </div>
                                            </div>
                                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: 28 }}>
                                                <SelectLabel style={{ fontSize: "18px", color: "white", fontWeight: 600, lineHeight: '22px', marginRight: '16px' }}>
                                                    Amount:
                                                </SelectLabel>
                                                <NumericalInputContainer>
                                                    <StyledNumericalInput
                                                        className='token-amount-input'
                                                        value={amount}
                                                        onUserInput={onUserInput}
                                                        maxBalance={100}
                                                        disabled={false}
                                                        style={{ width: '100%', textAlign: 'right', padding: '0 20px' }}
                                                        $loading={loading}
                                                    />
                                                </NumericalInputContainer>
                                            </div>
                                        </div>
                                    }
                                </RowBetween>
                            </div>
                            <div style={{ display: collapse ? 'none' : 'flex', justifyContent: 'center', transition: '0.5s' }}>
                                {
                                    positionType === CAPITAL_TYPE.DEPOSIT &&
                                    <button className={(positionAmount <= 0 || nftItem === null) ? "primary-button-invalid" : "primary-button"} onClick={onDeposit} style={{ marginTop: 10 }}>
                                        <p>Deposit</p>
                                    </button>
                                }
                                {
                                    positionType === CAPITAL_TYPE.WITHDRAW &&
                                    <button className={(positionAmount <= 0 || nftItem === null || notEnoughAllowance) ? "primary-button-invalid" : "primary-button"} onClick={onWithdraw} style={{ marginTop: 10 }}>
                                        <p>Withdraw</p>
                                    </button>
                                }
                                {
                                    positionType === CAPITAL_TYPE.DELEGATE &&
                                    <button className={(invalidAddress || invalidAmount || positionAmount <= 0) ? 'primary-button-invalid' : 'primary-button'} onClick={onDelegate}>
                                        {
                                            invalidAddress ?
                                                <p>Invalid Address</p>
                                                :
                                                (
                                                    invalidAmount ?
                                                        <p>Invalid Amount</p>
                                                        :
                                                        (
                                                            positionAmount > 0
                                                              ?
                                                              <p>Delegate</p>
                                                              :
                                                              <p>Invalid Amount</p>
                                                        )
                                                )
                                        }
                                    </button>
                                }
                                {
                                    positionType === CAPITAL_TYPE.UNDELEGATE &&
                                    <button className={(!address || invalidAmount || positionAmount <= 0 || parseFloat(delegatedAllowance) < parseFloat(capPerDDC) * amount) ? 'primary-button-invalid' : 'primary-button'} onClick={onUndelegate}>
                                        {
                                            !address ?
                                                <p>Select Address</p>
                                                :
                                                (
                                                    invalidAmount ?
                                                        <p>Invalid Amount</p>
                                                        :
                                                        (
                                                            positionAmount > 0
                                                            ?
                                                                <p>Undelegate</p>
                                                            :
                                                                <p>Invalid Amount</p>
                                                        )
                                                )
                                        }
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </>
            </RowBetween >
        </>
    )
}
